<template>
    <div class="form-group col-md-6">
        <label for="state" class="mb-0"> {{ $t('state') }} </label>
        <app-input 
            id="state" 
            class="form-control" 
            :placeholder="$t('select_state')"
            type="advance-search-select"
            :fetch-url='`/countries/${country_id}/states`'
            v-model="selected" 
            listValueField="name" 
            :loaded-per-time="5"  />
    </div>
</template>

<script>
    export default {
        name: 'stateAddress',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
            country_id :{
                type: [String, Number, Object],
                default: null
            }
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>
